<template>
  <div>
    <profile-card />
    <setting-list :settings="settings" @itemclick="onItemClick" />
  </div>
</template>

<script>
import SettingList from "@/components/SettingList.vue";
import ProfileCard from "@/components/ProfileCard.vue";
const cloudUrl = process.env.VUE_APP_CLOUD_URL;
import weixin from "@/mixins/weixin";
import Session from '@/util/session';
const desktopUrl = process.env.VUE_APP_DESKTOP_URL;
const isTablet = function() {
  const userAgent = window.navigator.userAgent;
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  return /Tablet|Android|Mobi|iPhone/i.test(userAgent) || (screenWidth >= 768 && screenWidth <= 1024);
}

export default {
  components: {
    SettingList,
    ProfileCard
  },
  mixins: [weixin],
  data() {
    const me = this;
    let data = {
      settings: [
        {
          title: "邀请同事",
          path: "/sys/invite_colleague",
          icon: "iconfont icon-yaoqing"
        },
        {
          title: "合作伙伴",
          path: "/partner_list",
          icon: "iconfont icon-partner"
        },
        {
          title: "财务设置",
          expand: false,
          icon: "iconfont icon-setting",
          items: [
            {
              title: "汇率",
              path: "/document/currency_list"
            },
            {
              title: "科目",
              path: "/finance/category_list"
            },
            {
              title: "银行账户",
              path: "/finance/bank_list"
            },
            {
              title: "税率",
              path: "/finance/tax_edit"
            },
            {
              title: "本位币",
              path: "/finance/currency_st_edit"
            },
            {
              title: "业务关联科目",
              path: "/finance/biz_category_list"
            },
            {
              title: "收款方式设置",
              path: "/finance/paymentsrec_list"
            },
            {
              title: "付款方式设置",
              path: "/finance/paymentspay_list"
            }
          ]
        },
        {
          title: "系统设置",
          expand: false,
          icon: "iconfont icon-manage",
          items: [
            {
              title: "公司资料",
              path: "/sys/company_edit"
            },
            {
              title: "岗位列表",
              path: "/sys/role_list"
            },
            {
              title: "人员组织",
              path: "/sys/org/0"
            },
            {
              title: "单据编码规则",
              path: "/sys/code_rule_list"
            },
            {
              title: "电子印章",
              path: "/sys/seal_edit"
            }
          ]
        },
        {
          title: "AI智能顾问",
          path: "/chatbot",
          icon: "iconfont icon-help"
        },
        {
          title: "华商云服",
          url: cloudUrl,
          icon: "iconfont icon-home",
          name: 'cloud'
        },
        {
          title: "专属顾问",
          path: "/partner/adviser",
          icon: "iconfont icon-audio"
        }
      ]
    };

    if (isTablet()) {
      data.settings.push({
        title: '切换到电脑版',
        name: 'switchDesktop',
        icon: "iconfont icon-desktop"
      });
    }

    if (!me.isWxWorkClient() && !me.isWeixinClient()) {
      data.settings.push({
        title: '退出登录',
        name: 'logout',
        icon: "iconfont icon-logout"
      });
    }

    return data;
  },

  methods: {
    onWxEnabled() {
      // 小程序环境，js域名均需要认证，先关闭入口
      const me = this;
      me.isMiniProgram().then(function(res) {
        if (res) {
          let index = me.settings.findIndex(i => i.name == 'cloud');
          if (index >= 0) {
            me.settings.splice(index, 1);
          }
          index = me.settings.findIndex(i => i.name == 'logout');
          if (index >= 0) {
            me.settings.splice(index, 1);
          }
        }
      });
    },
    onItemClick(item) {
      if (item.name == 'switchDesktop') {
        let session = Session.get();
        window.location.href = desktopUrl + "/" + session.appId.replace("-app", "") + "/?deviceType=Desktop#authorize/" + session.token;
      } else if (item.name == 'logout') {
        Session.remove();
        this.$router.replace({
          name: 'Login'
        });
      }
    }
  }
};
</script>
